var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',_vm._b({class:{
    'x-checkbox-tristate-red': _vm.indeterminate
  },attrs:{"value":_vm.localValue,"indeterminate":_vm.indeterminate,"true-value":true,"false-value":false},on:{"click":_vm.click}},'v-checkbox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }